import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    // Process all links with data-internal-link attribute
    function processInternalLinks() {
      const internalLinks = document.querySelectorAll('a[data-internal-link="true"]')

      internalLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          const ev = e as MouseEvent
          if (
            ev.button !== 0
            || ev.metaKey
            || ev.ctrlKey
            || ev.shiftKey
            || ev.altKey
          ) {
            return
          }
          e.preventDefault()
          const href = link.getAttribute('href')
          if (href) {
            navigateTo(href)
          }
        })
      })
    }
    
    // Process links on initial load
    processInternalLinks()
    
    // Set up a MutationObserver to handle dynamically added links
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as Element
              if (element.querySelector('a[data-internal-link="true"]')) {
                shouldProcess = true
                break
              }
            }
          }
        }
      })
      
      if (shouldProcess) {
        processInternalLinks()
      }
    })
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
})
